import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// 3rd party Modules
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { RxReactiveDynamicFormsModule } from '@rxweb/reactive-dynamic-forms';
import { NgxLoadingModule } from 'ngx-loading';
// Own Modules
import { SharedModule } from '../../../shared/shared.module';
import { AdministrationRoutingModule } from './administration-routing.module';
// Components
import { RutasComponent } from './rutas/rutas.component';
import { UnidadesComponent } from './unidades/unidades.component';
import { RutasEditCreateComponent } from './rutas/modal/edit-create/edit-create.component';
import { UnidadesEditCreateComponent } from './unidades/modal/edit-create/edit-create.component';
// Services
import { FormService } from '../../../shared/services/form.service';
import { RouterosBoxesComponent } from './routeros-boxes/routeros-boxes.component';

@NgModule({
    declarations: [
        RutasComponent,
        UnidadesComponent,
        RutasEditCreateComponent,
        UnidadesEditCreateComponent,
	    RouterosBoxesComponent,

    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RxReactiveFormsModule,
        RxReactiveDynamicFormsModule,
        NgxLoadingModule,
        AdministrationRoutingModule,
        SharedModule
    ],
    providers: [
        FormService
    ]
})
export class AdministrationModule { }
